"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const yup = __importStar(require("yup"));
const react_hook_form_1 = require("react-hook-form");
const react_router_dom_1 = require("react-router-dom");
const yup_1 = require("@hookform/resolvers/yup");
const auth_api_1 = require("../../../utils/api/auth/auth.api");
const Utils_1 = require("../../../utils/Utils");
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
function UseLoginForm() {
    const validationSchema = yup.object().shape({
        email: yup
            .string()
            .email("Adresse email invalide")
            .required("L'email est un champ requis")
            .matches(/@(eiffage\.com|volkeno\.sn)$/i, "L'adresse email doit appartenir au domaine eiffage.com")
            .label("L'email"),
        password: yup
            .string()
            .required("Le mot de passe est un champs requis")
            .label("Le mot de passe"),
    });
    const { register, handleSubmit, formState: { errors }, clearErrors, setError, } = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(validationSchema),
    });
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [loginUser, { isLoading, data }] = (0, auth_api_1.useLoginUserMutation)();
    const [urlParams] = (0, react_router_dom_1.useSearchParams)();
    (0, react_1.useEffect)(() => {
        (0, Utils_1.cleannerError)(errors, clearErrors);
    }, [errors, clearErrors]);
    const onSubmit = (data) => __awaiter(this, void 0, void 0, function* () {
        try {
            const res = yield loginUser(data).unwrap();
            react_hot_toast_1.default.success(res === null || res === void 0 ? void 0 : res.message, {
                duration: 5000,
                position: "top-center",
            });
            let path = `/double-authentification/${res === null || res === void 0 ? void 0 : res.user_id}`;
            const prev = urlParams.get("redirectTo");
            if (prev !== null) {
                navigate(`${path}?redirectTo=${prev}`, {
                    replace: true,
                    state: { email: data === null || data === void 0 ? void 0 : data.email },
                });
            }
            else {
                navigate(path, {
                    replace: true,
                    state: { email: data === null || data === void 0 ? void 0 : data.email },
                });
            }
        }
        catch (error) {
            console.log("error", error);
            const status = error === null || error === void 0 ? void 0 : error.status;
            const apiData = (error === null || error === void 0 ? void 0 : error.data) || {};
            if (status === 422) {
                const errors = apiData.errors || {};
                const message = Object.values(errors).flat().join("\n");
                react_hot_toast_1.default.error(message || "Erreur de validation.", {
                    duration: 5000,
                    position: "top-center",
                });
                return;
            }
            if (status === 401 || (apiData === null || apiData === void 0 ? void 0 : apiData.status_label) === "Unauthorized") {
                react_hot_toast_1.default.error((apiData === null || apiData === void 0 ? void 0 : apiData.message) ||
                    "Votre mot de passe ou votre adresse email n'est pas correct.", {
                    duration: 5000,
                    position: "top-center",
                });
                return;
            }
            if (status === 403 || (apiData === null || apiData === void 0 ? void 0 : apiData.is_active) === false) {
                react_hot_toast_1.default.error((apiData === null || apiData === void 0 ? void 0 : apiData.message) || "Votre compte a été désactivé.", {
                    duration: 5000,
                    position: "top-center",
                });
                return;
            }
            react_hot_toast_1.default.error((apiData === null || apiData === void 0 ? void 0 : apiData.message) ||
                `Erreur ${status || ""} : Une erreur est survenue.`, {
                duration: 5000,
                position: "top-center",
            });
        }
    });
    return {
        register,
        errors: errors,
        onSubmit: handleSubmit(onSubmit),
        isLoading,
    };
}
exports.default = UseLoginForm;
